import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

interface member {
  profile: string,
  list: string[],
  name: string,
  designation: string,
};

@Component({
  selector: 'app-page-aboutus',
  templateUrl: './page-aboutus.component.html',
  styleUrls: ['./page-aboutus.component.css']
})

/**
 * Aboutus Component
 */
export class PageAboutusComponent implements OnInit {

      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true
  /**
   * Member Data
   */
  memberData: member[] = [
    {
      profile: "assets/dodson.jpeg",
      list: ['facebook', "instagram", "twitter", "linkedin"],
      name: "Ill. Sir Marcelo Sans Dodson",
      designation: "Presidente (AMAL)",
    },
    {
      profile: "assets/claudio.jpg",
      list: ["facebook", "instagram", "twitter", "linkedin"],
      name: "Ill. Sir Claudio Sousa Lima",
      designation: "1º Vic. Presidente (Hikmat)",
    },
    {
      profile: "assets/images/client/02.jpg",
      list: ["facebook", "instagram", "twitter", "linkedin"],
      name: "N. Carlos A. Lopez-Granado",
      designation: "2º Vic. Presidente (Abou Saad)"
    },
    {
      profile: "assets/luiz-eduardo.jpeg",
      list: ["facebook", "instagram", "twitter", "linkedin"],
      name: " Ill. Sir Luís Eduardo Silva de Barros",
      designation: "3º Vic. Presidente (Salah)"
    },
    {
      profile: "assets/images/client/03.jpg",
      list: ["facebook", "instagram", "twitter", "linkedin"],
      name: "Ill. Sir Javier Lopez",
      designation: "Secretário (Al Atfal)"
    },
    {
      profile: "assets/images/client/03.jpg",
      list: ["facebook", "instagram", "twitter", "linkedin"],
      name: " Ill. Sir Miguel Brostella",
      designation: "Tesoureiro (Abou Saad)"
    }
  ];

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  /**
  * Open modal for show the video
  * @param content content of modal
  */
  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

}
